import AuthStore from 'auth/AuthStore'
import Loader from 'reusable/mobx-helpers/Loader'

interface AuthValidateEmailLinkStoreParams {
   authStore: AuthStore
   token: string
   userId: string
   emailId: string
}

export default class AuthValidateEmailLinkStore {
   sp
   loader = new Loader()
   newEmailLinkSent = false

   constructor(sp: AuthValidateEmailLinkStoreParams) {
      this.sp = sp
   }

   requestNewEmailLink = async () => {
      await this.loader.executeLoading(async () => {
         await this.sp.authStore.requestNewEmailLink(this.sp.userId, this.sp.token, this.sp.emailId)
         this.newEmailLinkSent = true
      })
   }
}
